//
export default {
    high: "#C21B7A",
    low:  "#0078F2"
}


